import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'errorsFormatingAndTranslate',
  standalone: false,
})
export class ErrorsFormatingAndTranslatePipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  private currentLang: string;

  public defaultErrorMessage = 'COMMON.VALIDATOR.DEFAULT';

  public errorNames: { [key: string]: string } = {
    require: 'COMMON.VALIDATOR.FIELD_IS_REQUIRED',
    required: 'COMMON.VALIDATOR.FIELD_IS_REQUIRED',
    pattern: 'COMMON.VALIDATOR.FIELD_INCORRECT',
    email: 'COMMON.VALIDATOR.INVALID_EMAIL',
    emailTaken: 'COMMON.VALIDATOR.EMAIL_TAKEN_ERROR',
    confirmEmail: 'COMMON.VALIDATOR.CONFIRM_EMAIL_ERROR',
    invalidDateDDMMYYYY: 'COMMON.VALIDATOR.INVALID_DATE_DDMMYYYY',
    invalidDateMMYYYY: 'COMMON.VALIDATOR.INVALID_DATE_MMYYYY',
    invalidDateYYYY: 'COMMON.VALIDATOR.INVALID_DATE_YYYY',
    providedDateAfterMaximumDate: 'COMMON.VALIDATOR.PROVIDED_DATE_AFTER_MAXIMUM_DATE',
    providedDateBeforeMinimumDate: 'COMMON.VALIDATOR.PROVIDED_DATE_BEFORE_MINIMUM_DATE',
    providedDateMustBeInThePast: 'COMMON.VALIDATOR.DATE_MUST_BE_IN_THE_PAST',
    providedDateMustBeInTheFuture: 'COMMON.VALIDATOR.DATE_MUST_BE_IN_THE_FUTURE',
    visaExpiredBeforeLastEntryDate: 'COMMON.VALIDATOR.VISA_EXPIRED',
    tooShort: 'COMMON.VALIDATOR.VALUE_TOO_SHORT',
    tooLong: 'COMMON.VALIDATOR.VALUE_TOO_LONG',
    minlength: 'COMMON.VALIDATOR.VALUE_TOO_SHORT',
    maxlength: 'COMMON.VALIDATOR.VALUE_TOO_LONG',
    max: 'COMMON.VALIDATOR.VALUE_TOO_BIG',
    min: 'COMMON.VALIDATOR.VALUE_TOO_SMALL',
    outOfRange: 'COMMON.VALIDATOR.VALUE_OUT_OF_RANGE',
    notAllowed: 'COMMON.VALIDATOR.VALUE_NOT_ALLOWED',
    comparisonInvalid: 'COMMON.VALIDATOR.COMPARISON_DATE',
    wrongPesel: 'COMMON.VALIDATOR.INVALID_PESEL',
    notInteger: 'COMMON.VALIDATOR.VALUE_NOT_INTEGER',
    invalidPhoneNumber: 'COMMON.VALIDATOR.INVALID_PHONE_NUMBER',
  };

  transform(errors: { [key: string]: any }): string {
    if (!errors) {
      return '';
    }

    this.currentLang = this.translateService.currentLang;

    for (const errorName in errors) {
      if (this.errorNames.hasOwnProperty(errorName)) {
        return this.translateService.instant(this.errorNames[errorName]);
      }
    }
    return this.translateService.instant(this.defaultErrorMessage);
  }
}
